import { action } from 'easy-peasy';
import initStore from '../initStore';
import { IActionResetTriageRequest } from '../types';

const resetTriageRequest: IActionResetTriageRequest = action(state => {
  const { request } = initStore;

  state.request = request;
});

export default resetTriageRequest;
